/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {CompileIdentifierMetadata} from '../compile_metadata';

export class ViewClassDependency {
/**
 * @param {?} comp
 * @param {?} name
 * @param {?} placeholder
 */
constructor(
public comp: CompileIdentifierMetadata,
public name: string,
public placeholder: CompileIdentifierMetadata) {}
}

function ViewClassDependency_tsickle_Closure_declarations() {
 /** @type {?} */
ViewClassDependency.prototype.comp;
 /** @type {?} */
ViewClassDependency.prototype.name;
 /** @type {?} */
ViewClassDependency.prototype.placeholder;
}


export class ComponentFactoryDependency {
/**
 * @param {?} comp
 * @param {?} placeholder
 */
constructor(
public comp: CompileIdentifierMetadata,
public placeholder: CompileIdentifierMetadata) {}
}

function ComponentFactoryDependency_tsickle_Closure_declarations() {
 /** @type {?} */
ComponentFactoryDependency.prototype.comp;
 /** @type {?} */
ComponentFactoryDependency.prototype.placeholder;
}


export class DirectiveWrapperDependency {
/**
 * @param {?} dir
 * @param {?} name
 * @param {?} placeholder
 */
constructor(
public dir: CompileIdentifierMetadata,
public name: string,
public placeholder: CompileIdentifierMetadata) {}
}

function DirectiveWrapperDependency_tsickle_Closure_declarations() {
 /** @type {?} */
DirectiveWrapperDependency.prototype.dir;
 /** @type {?} */
DirectiveWrapperDependency.prototype.name;
 /** @type {?} */
DirectiveWrapperDependency.prototype.placeholder;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
